import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import {
  kickstarterApi,
  type VerifyEmailRequest,
  type VerifyEmailResponse,
} from "../api/kickstarter.api";

export function useVerifyEmail(): UseMutationResult<
  VerifyEmailResponse,
  Error,
  VerifyEmailRequest
> {
  return useMutation({
    mutationFn: (data: VerifyEmailRequest) => kickstarterApi.verifyEmail(data),
    onError: (error) => {
      console.error("Email verification error:", error);
    },
  });
}
